import {
  Card,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import '../../pages/GrowthHackTableData/GrowthHackTableData.scss';
import { useMemo } from 'react';

const BulletCard = ({ nextStepsText, recommendationsText }) => {

  const parseContent = (text) => {
    const raw = typeof text === 'string' ? text : '';
    if (!raw.trim()) return { headerItems: [], bulletItems: [] };

    const normalized = raw.replace(/\r\n/g, '\n');
    const headerItems = [];
    const bulletItems = [];

    if (normalized.includes('##')) {
      const [headerChunk, ...bulletChunks] = normalized.split(/##\s*/);

      headerChunk
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean)
        .forEach(line => headerItems.push(line));

      bulletChunks
        .map(chunk =>
          chunk
            .split('\n')
            .map(line => line.trim())
            .filter(Boolean)
            .join(' ')
        )
        .filter(Boolean)
        .forEach(item => bulletItems.push(item));
    } else {
      const paragraph = normalized
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean)
        .join(' ')
        .trim();

      if (paragraph) {
        headerItems.push(paragraph);
      }
    }

    return { headerItems, bulletItems };
  };

  const nextStepsData = useMemo(() => parseContent(nextStepsText), [nextStepsText]);
  const recommendationData = useMemo(() => parseContent(recommendationsText), [recommendationsText]);

    
  return (
      <div className="row gy-4">
        <div className="col-lg-6">
          <Card className="bullet-card info-card-content">
            <Typography variant="h6" className="card-title">Recommendations</Typography>
            {recommendationData.headerItems.length === 0 && recommendationData.bulletItems.length === 0 ? (
              <Typography variant="body2" className='list-text'>Not available</Typography>
            ) : (
              <List dense>
                {recommendationData.headerItems.map((text, index) => (
                  <ListItem key={`header-${index}`} disableGutters alignItems="flex-start">
                    <ListItemText primary={text} className='list-text' />
                  </ListItem>
                ))}
                {recommendationData.bulletItems.map((text, index) => (
                  <ListItem key={`bullet-${index}`} disableGutters alignItems="flex-start">
                    <ListItemIcon className="custom-list-item-icon">
                      <FiberManualRecordIcon sx={{ fontSize: '0.6rem' }}/>
                    </ListItemIcon>
                    <ListItemText primary={text} className='list-text' />
                  </ListItem>
                ))}
              </List>
            )}
          </Card>
        </div>
        <div className="col-lg-6">
          <Card className="bullet-card info-card-content">
            <Typography variant="h6" className="card-title">Immediate Next Steps</Typography>
            {nextStepsData.headerItems.length === 0 && nextStepsData.bulletItems.length === 0 ? (
              <Typography variant="body2" className='list-text'>Not available</Typography>
            ) : (
              <List dense>
                {nextStepsData.headerItems.map((text, index) => (
                  <ListItem key={`header-${index}`} disableGutters alignItems="flex-start">
                    <ListItemText primary={text} className='list-text'/>
                  </ListItem>
                ))}
                {nextStepsData.bulletItems.map((text, index) => (
                  <ListItem key={`bullet-${index}`} disableGutters alignItems="flex-start">
                    <ListItemIcon className="custom-list-item-icon">
                      <FiberManualRecordIcon sx={{ fontSize: '0.6rem' }}/>
                    </ListItemIcon>
                    <ListItemText primary={text} className='list-text'/>
                  </ListItem>
                ))}
              </List>
            )}
          </Card>
        </div>
      </div>
  )
}

export default BulletCard;